import { IInventorySummaryData } from "../types/IInventorySummaryData";




export function aggregateDataBySalesChannel(data: IInventorySummaryData[] | undefined) {
    if (!data) return
    // let distinctConcatenatedIds = [...new Set(data.map((obj) => `${obj[filter.axisData?.yAxis.idKey as string]}-${obj[filter.axisData?.xAxis.idKey as string]}-${obj[filter.axisData?.filter.idKey as string]}`))]
    const distinctConcatenatedIds = [
        ...new Set(
            data.map(
                (obj) =>
                    `${obj.classificationVolumeId}-${obj.classificationUncertaintyId}-${obj.classificationComplexityId}-${obj.customerGroupId}`
            )
        ),
    ];


    const result = distinctConcatenatedIds.map((concatenatedId) => {
        const filteredObjects = data
            .filter(
                (obj) =>
                    `${obj.classificationVolumeId}-${obj.classificationUncertaintyId}-${obj.classificationComplexityId}-${obj.customerGroupId}` ===
                    concatenatedId
            );
        const totalCycleStockValue = filteredObjects.reduce((sum, obj) => sum + obj.cycleStockValue, 0);
        const totalCycleStockDays = filteredObjects.reduce((sum, obj) => sum + obj.cycleStockDays, 0);
        const totalSafetyStockValue = filteredObjects.reduce((sum, obj) => sum + obj.safetyStockValue, 0);
        const totalSafetyStockDays = filteredObjects.reduce((sum, obj) => sum + obj.safetyStockDays, 0);

        const totalStockValue = totalCycleStockValue + totalSafetyStockValue;  // Sum of cycleStockValue and safetyStockValue

        const weightedSumSafetyStockDays = filteredObjects.reduce((sum, obj) => sum + obj.safetyStockValue * (isNaN(obj.safetyStockDays) ? 0 : obj.safetyStockDays), 0);
        const weightedAvgSafetyStockDays = (weightedSumSafetyStockDays / totalSafetyStockValue) || 0;

        const weightedSumCycleStockDays = filteredObjects.reduce((sum, obj) => sum + obj.cycleStockValue * (isNaN(obj.cycleStockDays) ? 0 : obj.cycleStockDays), 0);
        const weightedAvgCycleStockDays = (weightedSumCycleStockDays / totalCycleStockValue) || 0;

        const weightedSumServiceLevelPerc = filteredObjects.reduce((sum, obj) => sum + (obj.cycleStockValue + obj.safetyStockValue) * obj.serviceLevelPerc, 0);
        const weightedAvgServiceLevelPerc = (weightedSumServiceLevelPerc / totalStockValue);

        const totalItensQuantity = filteredObjects.reduce((sum, obj) => sum + obj.itensQuantity, 0);


        // Extracting the first object to include all other keys from the original object
        const {
            classificationVolumeId,
            classificationUncertaintyId,
            classificationComplexityId,
            classificationComplexity,
            classificationComplexityPriority,
            classificationUncertainty,
            classificationUncertaintyPriority,
            classificationVolume,
            classificationVolumePriority,
            customerGroupPriority, customerGroup, customerGroupId, stockGroupId, stockGroupPriority, salesChannel, salesChannelId, salesChannelPriority,
            stockGroup,
            color,
            company,
            companyId,
        } = filteredObjects[0];
        return {
            classificationComplexity,
            classificationComplexityId,
            classificationComplexityPriority,
            classificationUncertainty,
            classificationUncertaintyId,
            classificationUncertaintyPriority,
            classificationVolume,
            classificationVolumeId,
            classificationVolumePriority,
            customerGroupPriority,
            customerGroup,
            customerGroupId,
            stockGroupId,
            stockGroupPriority,
            stockGroup,
            salesChannel: "Todos",
            salesChannelId,
            salesChannelPriority,
            serviceLevelPerc: weightedAvgServiceLevelPerc,
            company,
            companyId,
            cycleStockDays: weightedAvgCycleStockDays,
            cycleStockValue: totalCycleStockValue,
            itensQuantity: totalItensQuantity,
            safetyStockDays: weightedAvgSafetyStockDays,
            safetyStockValue: totalSafetyStockValue,
            color,
        };
    });
    return result;
}
